import Modal from 'antd/es/modal';
import React, { useCallback, useEffect, useRef, Suspense, useState } from 'react';
import { CLOSE_LOGIN_POPUP } from '../../redux/actions/accountActions';
import { OPEN_ACTION_MODAL_CHILD, CLOSE_ACTION_MODAL_CHILD } from '../../redux/actions/componentsActions';
import { TRACK_LIVE_STREAM_WATCH } from '../../redux/actions/currentStreamActions';

import { useDispatch, useSelector } from 'react-redux';
import { getCommonRoutePath, isSafariBrowser } from '../../helpers/Helpers';
import { timeToStartStream } from '../../helpers/liveStreamHelper';
import { useNavigate } from 'react-router';

const LoginComponent = React.lazy(() => import(/* login-component */ '../auth'));
const StreamSubscriptionPopup = React.lazy(() => import('../popups/StreamSubscriptionPopup'));

import { LIVE_STREAM_STATUS } from '../../common/constants';

const LoginPopup = ({ bodyStyles = {} }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const modalRef = useRef(null);
    const { isOpened, university, id, userId, name, type, slug, subType } = useSelector((state) => state.loginPopup);
    const { isMobile } = useSelector((state) => state.widget);
    const { registrationEvent } = useSelector((state) => state.liveStreams);

    useEffect(() => {
        let timeout;
        const isSafari = isSafariBrowser();
        if (isOpened) {
            if (modalRef.current) {
                isSafari
                    ? window.parent.postMessage('safariScrollToTop', '*')
                    : modalRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                timeout = setTimeout(() => {
                    isSafari
                        ? window.parent.postMessage('safariScrollToTop', '*')
                        : modalRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 500);
            }
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isOpened]);

    const onWatchClick = useCallback(() => {
        if (isMobile) {
            window.open(getCommonRoutePath() + '/live-streams/' + slug, '_blank');
        } else {
            navigate(getCommonRoutePath() + '/live-streams/' + slug);
        }
        dispatch({
            type: CLOSE_ACTION_MODAL_CHILD,
        });
    }, [slug, dispatch, isMobile]);

    const handleLoginSuccess = useCallback(
        (accountInfo) => {
            handleCloseLoginPopup();
            if (type === 'live-stream') {
                const prospectIds = registrationEvent.registeredProspectIds
                    ? registrationEvent.registeredProspectIds
                    : [];
                const isProspectEnrolled = prospectIds.some((prospect) => prospect === accountInfo?.id);

                const timeToStart = timeToStartStream(registrationEvent);

                const isSignUpStreamFlow =
                    timeToStart > 10 && registrationEvent.status === LIVE_STREAM_STATUS.UPCOMING && !isProspectEnrolled;

                if (isSignUpStreamFlow && accountInfo?.key === 'prospect') {
                    dispatch({
                        type: OPEN_ACTION_MODAL_CHILD,
                        payload: {
                            children: <StreamSubscriptionPopup onWatchClick={onWatchClick} />,
                        },
                    });
                    dispatch({
                        type: TRACK_LIVE_STREAM_WATCH,
                        payload: {
                            liveStreamId: registrationEvent.id,
                            prospectId: accountInfo.id,
                        },
                    });
                } else {
                    if (isMobile) {
                        window.open(getCommonRoutePath() + '/live-streams/' + slug, '_blank');
                    } else {
                        navigate(getCommonRoutePath() + '/live-streams/' + slug);
                    }
                }
            } else if (type === 'group-chat' || type === 'forum') {
                if (
                    type === 'group-chat' ||
                    (type === 'forum' && accountInfo && accountInfo.id && accountInfo.key !== 'prospect')
                ) {
                    navigate(getCommonRoutePath() + '/interaction/dialogs/' + id);
                }
            } else if (!subType) {
                navigate(getCommonRoutePath() + '/interaction/' + (userId || id));
            }
        },
        [navigate, type, id, isMobile, registrationEvent]
    );

    const handleCloseLoginPopup = useCallback(() => {
        dispatch({
            type: CLOSE_LOGIN_POPUP,
        });
    }, [dispatch]);

    return (
        <Modal
            open={isOpened}
            styles={{ body: { padding: 0 } }}
            width={470}
            footer={null}
            closable={true}
            maskClosable={true}
            onCancel={handleCloseLoginPopup}
            className="register-modal"
        >
            <div ref={modalRef}>
                <Suspense fallback={null}>
                    <LoginComponent
                        university={university}
                        name={name}
                        handleClosePopup={handleCloseLoginPopup}
                        redirectToChat
                        id={id}
                        modalBodyStyles={bodyStyles}
                        type={type}
                        userAction={type === 'ambassador' || type === 'post' || type === 'faq'}
                        groupChatAction={type === 'group-chat'}
                        liveStreamAction={type === 'live-stream'}
                        forumChatAction={type === 'forum'}
                        onLoginSuccess={handleLoginSuccess}
                    />
                </Suspense>
            </div>
        </Modal>
    );
};

export default LoginPopup;
